type Density = 'comfortable' | 'dense';

export const inputClass = (hasError: boolean, disabled?: boolean, density: Density = 'comfortable') => {
  const border = hasError ? 'border-red-200 focus:border-red-300' : 'border-slate-200 focus:border-brand-500';
  const bg = disabled ? 'bg-slate-50 text-slate-500 cursor-not-allowed' : 'bg-white/70';
  const padding = density === 'dense' ? 'h-9 px-3' : 'px-4 py-3';

  return `min-w-0 w-full rounded-xl border ${padding} text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-200 ${border} ${bg}`;
};
